<template>
  <div class="offline-office">
    <div class="offline-office-bg" @click="hide" v-show="isShow"></div>
    <transition name="fade">
      <div class="offline-office-list" v-show="isShow">
        <div class="offline-office-header">{{config.title}}</div>
        <ul class="offline-office-content">
          <li @click="handleClick('tel',telItem)">
            <a class="offline-office-item">
              <div class="offline-office-content-left">
                <i class="i-service"></i>
              </div>
              <div class="offline-office-content-mid">
                <div class="offline-office-content-title">{{telItem.title}}</div>
                <div class="offline-office-content-desc">{{telItem.phone_number}}</div>
              </div>
              <div class="offline-office-content-right">
                <i class="i-tel"></i>
              </div>
            </a>
          </li>
          <template v-if="lineSite.length">
            <li @click="handleClick('nav',item)" :key="index" v-for="(item, index) in lineSite">
              <a class="offline-office-item">
                <div class="offline-office-content-left">
                  <i>{{iconArr[index]}}</i>
                </div>
                <div class="offline-office-content-mid">
                  <div class="offline-office-content-title">{{item.siteName}}</div>
                  <div class="offline-office-content-desc">{{item.businessHours}}</div>
                  <div class="offline-office-content-desc">{{item.siteAddress}}</div>
                </div>
                <div class="offline-office-content-right">
                  <i class="i-nav"></i>
                </div>
              </a>
            </li>
          </template>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { showAlertDialog } from "../../tools/Tip";
import { IOS_MAP_URL, ANDROID_MAP_URL, ends } from "../../tools/constant";

export default {
  props: ["config"],
  data() {
    return {
      isShow: false,
      lineSite: [],
      telItem: {}
    };
  },
  computed: {
    ...mapState(["_ticket", "_area","_open_type"]),
    iconArr() {
      const res = [];
      const A_CHAR_CODE = 65;
      const ARR_LENGTH = 26;
      for (let i = 0; i < ARR_LENGTH; i++) {
        res.push(String.fromCharCode(A_CHAR_CODE + i));
      }
      return res;
    },
    location_country() {
      return new URLSearchParams(location.search).get("location_country");
    }
  },
  methods: {
    getLineSite() {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (this._area.value && this._open_type) {
        up.set(this._open_type, this._area.value);
      }
      post(this.config.link, up)
        .then(res => {
          this.telItem = res.phone;
          if(this.location_country !== 'UA') {
            this.lineSite = res.sites;
          }
        })
        .catch(err => {
          showAlertDialog(this, err.errmsg);
        });
    },
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    outSideNav(item) {
      const { siteAddress } = item;
      const host = ends.isIOS ? IOS_MAP_URL : ANDROID_MAP_URL;
      const url = `${host}?daddr=${siteAddress}`;
      if (ends.isPC) {
        // 新打开一个tab，解决google X-Frame-Options的限制
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },
    createTel(number) {
      return `tel:${number}`;
    },
    handleClick(tag, item) {
      switch (tag) {
        case "nav":
          if (ends.inApp) {
            const params = {
              toName: item.siteAddress,
              toLat: item.lat,
              toLng: item.lng
            };
            this.isFleet && (params.external = 1);
            try {
              Fusion.launchNav(params);
            } catch (e) {}
          } else {
            // 端外调起导航
            this.outSideNav(item);
          }
          break;
        case "tel":
          window.location.href = this.createTel(item.phone_number);
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../css/mixin.scss";
.fade-enter-active,
.fade-leave-active {
  transform: translateY(0);
}
.fade-enter,
.fade-leave-to,
.fade-leave-active {
  transform: translateY(100%);
}
.offline-office {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 12;
  .offline-office-bg {
    top: 0;
    left: 0;
    position: fixed;
    height: 100%;
    width: 100%;
    background: #212a34;
    opacity: 0.5;
    z-index: 10;
  }
  .i-nav {
    @include bg-img("navigation");
  }
  .i-tel {
    @include bg-img("tel");
  }
  .i-service {
    @include bg-img("service");
  }
  .offline-office-list {
    transition: all 0.3s ease;
    width: 100%;
    position: absolute;
    bottom: 0;
    background: #fff;
    z-index: 11;
    max-height: 8rem;
    overflow: scroll;
    .offline-office-header {
      padding: 0.38rem 0;
      text-align: center;
      font-size: 0.38rem;
      color: #1f2933;
      @include border-1px(bottom);
    }
    .offline-office-content {
      .offline-office-item {
        padding: 0.28rem 0.36rem;
        display: flex;
        @include border-1px(bottom);
        .offline-office-content-left {
          margin-right: 0.3rem;
          > i {
            display: block;
            width: 0.4rem;
            height: 0.4rem;
            background-color: $main-orange;
            text-align: center;
            line-height: 0.4rem;
            font-style: normal;
            color: #fff;
            border-radius: 50%;
            font-size: 0.32rem;
          }
          .i-service {
            background-size: 0.4rem;
          }
        }
        .offline-office-content-mid {
          flex: 1;
          text-align: left;
          padding-right: 0.4rem;
          .offline-office-content-title {
            font-weight: 400;
            font-size: 0.38rem;
            color: #414141;
            margin-bottom: 0.1536rem;
          }
          .offline-office-content-desc {
            font-size: 0.28rem;
            color: #949494;
            margin-bottom: 0.04rem;
          }
        }
        .offline-office-content-right {
          > i {
            display: block;
            width: 0.352rem;
            height: 0.44rem;
            margin-top: 0.4rem;
            background-size: 0.352rem 0.44rem;
          }
          .i-tel {
            margin-top: 0.24rem;
          }
        }
      }
    }
  }
}
</style>
